import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { AuthCard } from './AuthLayout';
export function Register() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (password.length < 6) {
            setError(t('auth.passwordMinLength'));
            return;
        }
        if (password !== confirmPassword) {
            setError(t('auth.passwordsDoNotMatch'));
            return;
        }
        setLoading(true);
        try {
            const response = await fetch('/api/auth/register', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email,
                    password,
                    name,
                    surname,
                }),
            });
            const rawText = await response.text();
            let parsed = null;
            if (rawText) {
                try {
                    parsed = JSON.parse(rawText);
                }
                catch {
                    parsed = null;
                }
            }
            if (!response.ok) {
                const errorMessage = parsed?.message;
                throw new Error(errorMessage || (rawText ? rawText : t('auth.registrationFailed')));
            }
            navigate('/login', { state: { registered: true } });
        }
        catch (err) {
            setError(err instanceof Error ? err.message : t('auth.registrationFailed'));
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsxs(AuthCard, { title: t('auth.createAccountTitle'), subtitle: t('auth.createAccountSubtitle'), children: [error && _jsx("div", { className: "auth-error", children: error }), _jsxs("form", { onSubmit: handleSubmit, className: "auth-form", children: [_jsxs("div", { className: "auth-row", children: [_jsxs("div", { className: "auth-field", children: [_jsx("label", { htmlFor: "name", className: "auth-label", children: t('auth.name') }), _jsx("input", { id: "name", type: "text", value: name, onChange: (e) => setName(e.target.value), autoComplete: "given-name", className: "auth-input", placeholder: t('auth.namePlaceholder') })] }), _jsxs("div", { className: "auth-field", children: [_jsx("label", { htmlFor: "surname", className: "auth-label", children: t('auth.surname') }), _jsx("input", { id: "surname", type: "text", value: surname, onChange: (e) => setSurname(e.target.value), autoComplete: "family-name", className: "auth-input", placeholder: t('auth.surnamePlaceholder') })] })] }), _jsxs("div", { className: "auth-field", children: [_jsx("label", { htmlFor: "email", className: "auth-label", children: t('auth.email') }), _jsx("input", { id: "email", type: "email", value: email, onChange: (e) => setEmail(e.target.value), required: true, autoComplete: "email", className: "auth-input", placeholder: t('auth.emailPlaceholder') })] }), _jsxs("div", { className: "auth-field", children: [_jsx("label", { htmlFor: "password", className: "auth-label", children: t('auth.password') }), _jsx("input", { id: "password", type: "password", value: password, onChange: (e) => setPassword(e.target.value), required: true, minLength: 6, autoComplete: "new-password", className: "auth-input", placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022" })] }), _jsxs("div", { className: "auth-field", children: [_jsx("label", { htmlFor: "confirmPassword", className: "auth-label", children: t('auth.confirmPassword') }), _jsx("input", { id: "confirmPassword", type: "password", value: confirmPassword, onChange: (e) => setConfirmPassword(e.target.value), required: true, minLength: 6, autoComplete: "new-password", className: "auth-input", placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022" })] }), _jsxs("p", { className: "auth-terms-note", children: [t('auth.termsAgreePrefix'), ' ', _jsx(Link, { to: "/terms", className: "auth-link", children: t('auth.termsOfService') }), ' ', t('auth.and'), ' ', _jsx(Link, { to: "/privacy", className: "auth-link", children: t('auth.privacyPolicy') }), t('auth.termsAgreeSuffix')] }), _jsx("button", { type: "submit", disabled: loading, className: "auth-button", children: loading ? t('auth.creatingAccount') : t('auth.createAccount') })] }), _jsxs("div", { className: "auth-footer", children: [t('auth.hasAccount'), ' ', _jsx(Link, { to: "/login", className: "auth-link", children: t('auth.signInLink') })] })] }));
}
